import { createContext, useContext } from 'react';
const defaultContextValue = {
    identity: null,
    paragraphs: null,
    rawParagraphs: null,
    isLoading: false,
    error: null,
    // loadContent: async () => { console.warn("loadContent called on default TextDocumentContentContext"); },
};
export const CurrentTextDocumentContentContext = createContext(defaultContextValue);
/**
 * Custom hook to consume the CurrentTextDocumentContentContext.
 * Provides a convenient way to access text document content state.
 */
export function useCurrentTextDocumentContentContext() {
    const context = useContext(CurrentTextDocumentContentContext);
    if (context === undefined) {
        // This error means you tried to use the context outside of its provider
        throw new Error('useCurrentTextDocumentContentContext must be used within a CurrentTextDocumentContentContext.Provider');
    }
    return context;
}
//# sourceMappingURL=CurrentTextDocumentContentContext.js.map